package it.maicol07.gamerlogue

@Suppress("unused")
enum class AppEnvironment {
    LOCAL,
    PRODUCTION
}
